import { useAppMutation } from '@/hooks/api';
import { API_ROUTES } from '@/constants/api-routes';
import { TypedFormData } from '@/types/common';

export interface UploadTemplateResponse {
  _id: string;
  fileId: string;
}
export type UploadTemplateFormData = TypedFormData<{
  file: File;
  envelopeId: string;
  itemId: string;
}>;

export const useAddNewTemplateMutation = () => {
  return useAppMutation<UploadTemplateResponse, UploadTemplateFormData>({
    mutationKey: ['add-new-template'],
    routeName: API_ROUTES.UPLOAD_TEMPLATE_TO_GALLERY,
    method: 'POST',
  });
};
